import getFlightGroupKey from 'utils/getFlightGroupKey';
import getFlightGroupSummaryText from 'utils/getFlightGroupSummaryText';

import SelectableGrid from 'components/SelectableGrid';

import SelectableFlightsGridRow from './components/SelectableFlightsGridRow';
import { COLUMNS_VARIABLE, REPORT_COLUMNS, TEST_ID } from './constants';
import type { FlightResponse, FunctionComponent, Props } from './types';

const SelectableFlightsGrid: FunctionComponent<Props> = ({
    className = '',
    isLoading = false,
    onNext,
    onSelectionChange,
    rows = [],
    testId = TEST_ID
}) => (
    <SelectableGrid<FlightResponse>
        renderRow={(flight, isSelected, onSelect) => (
            <SelectableFlightsGridRow
                flight={flight}
                isSelected={isSelected}
                key={flight.id}
                onSelect={onSelect}
            />
        )}
        className={className}
        columns={REPORT_COLUMNS}
        columnsVariable={COLUMNS_VARIABLE}
        getGroupKey={getFlightGroupKey}
        getSummaryText={getFlightGroupSummaryText}
        isLoading={isLoading}
        onNext={onNext}
        onSelectionChange={onSelectionChange}
        rows={rows}
        testId={testId}
    />
);

export default SelectableFlightsGrid;
